import React, { PureComponent } from 'react'
import { Modal, Row, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputPercentage from '../../commons/form/InputPercentage'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class CodeCommissionMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      type: null,
      values: null,
      deleted: false
    }
    this.required = this.required.bind(this)
  }

  submitDocument (values) {
    var commissionCancellationCodeLanguage = []
    Object.keys(values).map(item => {
      if (item.includes('lang')) {
        commissionCancellationCodeLanguage.push(values[item])
      }
    })
    var codeCommission = {}
    codeCommission.commissionCancellationCodeId = this.props.codeCommission?.commissionCancellationCodeId
    codeCommission.code = values.code
    codeCommission.commissionCancellationCodeLanguage = commissionCancellationCodeLanguage
    codeCommission.organizedUnitId = values.organizedUnitId
    codeCommission.fixedPercentage = values.fixedPercentage
    codeCommission.qualitativePercentage = values.qualitativePercentage
    codeCommission.quantitativePercentage = values.quantitativePercentage

    this.props.actions.createOrUpdateCodeCommission(codeCommission, this.props.uoId)
  }

  required (value) {
    if (value || value === 0) {
      return undefined
    } else {
      return this.props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal, languageList,
      combos: { organizedUnitsAllCombo }
    } = this.props
    const tKey = 'MASTERS.CODE_COMMISSION.'
    return (
      <Modal id="CodeCommissionMasterModal" className="_nf languages-modal" show={showModal} onHide={this.props.actions.closeCodeCommissionModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeCodeCommissionModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="search-form">
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                t={t}
                id='code'
                name='code'
                placeholder={t(`${tKey}CODE`)}
                controlLabel={t(`${tKey}CODE`)}
                maxLength={20}
                validate={[this.required]}
              />
            </Row>
            <SimpleTablePage
              customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={0}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-85' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />

            <Row className="search-form">
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t('DOSSIER_COMPONENTS.HEADER.UO')}
                placeholder={t('DOSSIER_COMPONENTS.HEADER.UO')}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                validate={[this.required]}
                disabled={this.props.codeCommission?.isInUse}
              />
              <Field
                component={InputPercentage}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="fixedPercentage"
                name="fixedPercentage"
                type="text"
                controlLabel={t(`${tKey}FIXED_COMMISSION`)}
                placeholder={t(`${tKey}FIXED_COMMISSION`)}
                validate={[this.required]}
                maxLength={14}
              />
              <Field
                component={InputPercentage}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="quantitativePercentage"
                name="quantitativePercentage"
                type="text"
                controlLabel={t(`${tKey}QUANTITATIVE_COMMISSION`)}
                placeholder={t(`${tKey}QUANTITATIVE_COMMISSION`)}
                validate={[this.required]}
                maxLength={14}
              />
              <Field
                component={InputPercentage}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="qualitativePercentage"
                name="qualitativePercentage"
                type="text"
                controlLabel={t(`${tKey}QUALITATIVE_COMMISSION`)}
                placeholder={t(`${tKey}QUALITATIVE_COMMISSION`)}
                validate={[this.required]}
                maxLength={14}
              />
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-R">
              <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'codeCommissionMasterModal',
  validate: (values, props) => {
    let error = {}

    props.languageList && props.languageList?.forEach((element) => {
      let valueLangDesc = values['lang' + element.languageId]?.description
      let errorLang = {
        name: null,
        description: null
      }

      if (!valueLangDesc) {
        errorLang.description = props.t('DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD')
      }
      error['lang' + element.languageId] = errorLang
    })

    return Object.keys(error).length > 0 ? error : {}
  }
})(CodeCommissionMasterModal)
